import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { Link } from 'neon-design-system';
import { useHistory } from 'react-router-dom';
import { MouseEvent } from 'react';
import { PageGrid } from '../../../../components/PageGrid/PageGrid';
import { usePaginationRequestInfo } from '../../../../providers/PaginationRequestProvider';
import { CashMovementActivity } from '../../../../types/request';
import { localDateFormat } from '../../../../utils/date';
import { formatToLocaleString } from '../../../../utils/number';
import { activeFilterName } from '../../pages/CashMovementRequests/CashMovementRequests';
import { CashMovementStatusLabel } from '../CashMovementStatusLabel/CashMovementStatusLabel';
import {
    getCashMovementActivityDetailPath,
    getCashMovementActivityTypeLabel
} from '../../utils/activity';

interface Props {
    rowData: CashMovementActivity[];
    paginationPageSize?: number;
    currentPage?: number;
}

export const pageName = 'cash-movement-requests';

export const CashMovementRequestsGrid = ({ rowData, paginationPageSize, currentPage }: Props) => {
    const history = useHistory();
    const columnDefs: ColDef[] = [
        {
            field: 'reference',
            headerName: 'Request Ref.',
            sortable: true,
            cellRendererFramework: (p: ICellRendererParams) =>
                getCashMovementActivityDetailPath(p.data) ? (
                    <Link
                        to={getCashMovementActivityDetailPath(p.data)!}
                        onClick={(event: MouseEvent) => {
                            event.preventDefault();
                            history.push(getCashMovementActivityDetailPath(p.data)!);
                        }}
                    >
                        <b>{p.value}</b>
                    </Link>
                ) : (
                    <b>{p.value}</b>
                )
        },
        {
      field: 'activityType',
      headerName: 'Request Type',
      sortable: false,
            valueFormatter: ({ data }) => getCashMovementActivityTypeLabel(data)
        },
        {
            field: 'accountNumber',
            headerName: 'Client Account',
            sortable: true
        },
        {
            field: 'amount',
            headerName: 'Amount',
            sortable: true,
            headerClass: 'ag-right-aligned-header',
            type: 'rightAligned',
            valueFormatter: ({ value }) => {
                return formatToLocaleString(value);
            }
        },
        {
            field: 'currency',
            headerName: 'Currency',
            sortable: true
        },
        {
            field: 'usdEquivalent',
            headerName: 'USD Equivalent',
            sortable: false,
            headerClass: 'ag-right-aligned-header',
            type: 'rightAligned',
            valueFormatter: ({ value }) => {
                return value == null ? '' : formatToLocaleString(value);
            }
        },
        {
            field: 'paymentRequest.standardSettlementInstructionAlias',
            headerName: 'Standard Settlement Instruction',
            sortable: false
        },
        {
            field: 'activityDate',
            headerName: 'Activity Date',
            sortable: true,
            valueFormatter: ({ value }) => {
                return localDateFormat(new Date(value), true);
            }
        },
        {
      field: 'status',
      headerName: 'Status',
      sortable: false,
            cellRendererFramework: (p: ICellRendererParams) => {
                return (
                    <div>
                        <CashMovementStatusLabel status={p.data.status} />
                    </div>
                );
            }
        }
    ];

    const { onSortChanged } = usePaginationRequestInfo(activeFilterName);

    return (
        <PageGrid
            onSortChanged={onSortChanged}
            cols={columnDefs}
            rowData={rowData}
            paginationPageSize={paginationPageSize}
            currentPage={currentPage}
            pageName={pageName}
        />
    );
};
